import React from 'react';
import { Box, Typography, Button, Avatar, Grid } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Link } from 'react-router-dom';
import fotoKevin from 'assets/fotoKevin.png';
import fotoAna from 'assets/fotoAna.png';
import fotoGabriel from 'assets/fotoGabriel.png';
import hiCellLogo from 'assets/hiCellLogo.png';

const specialists = [
  {
    name: 'Garantia / Suporte',
    imageUrl: hiCellLogo,
    phone: '5549984256512'
  },
  {
    name: 'Kevin',
    imageUrl: fotoKevin,
    phone: '5549999988678',
  },
  {
    name: 'Ana',
    imageUrl: fotoAna,
    phone: '5549998325895',
  },
  {
    name: 'Gabriel',
    imageUrl: fotoGabriel,
    phone: '5549999328425',
  },
];

const generateWhatsappLink = (phone, name) => {
  const messageSupport = 'Olá, vim através do Site da Hi Cell, comprei um produto com vocês e ele apresentou um problema';
  const message = `Olá, ${name}! Vim pelo site da HiCell e gostaria de saber mais sobre os produtos.`;

  if (name === 'Garantia / Suporte') {
    const encodedSupportMessage = encodeURIComponent(messageSupport);
    return `https://wa.me/${phone}?text=${encodedSupportMessage}`;
  }

  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${encodedMessage}`;
};

const SpecialistsSession = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 4,
        px: 3,
        py: 4,
        bgcolor: 'black',
        color: 'white',
        borderRadius: 2,
        mt: 6,
        boxShadow: '0 0 16px rgba(146, 178, 31, 0.3)',
      }}
    >
      {/* TEXTO E BOTÃO PRINCIPAL */}
      <Box flex={1}>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: '1.2rem', md: '1.5rem' },
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#92b21f',
            textTransform: 'uppercase',
            mb: 2,
            textShadow: '0 0 6px rgba(146, 178, 31, 0.6)',
          }}
        >
          Fale com um de nossos especialistas!
        </Typography>

        {/* INSERÇÃO AQUI */}
        <Grid container spacing={2} justifyContent={'space-around'}>
          {specialists.map((spec) => (
            <Grid item xs={12} sm={6} md={3} key={crypto.randomUUID()}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.03)',
                  borderRadius: 2,
                  boxShadow: '0 0 8px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 0 16px rgba(146, 178, 31, 0.5)',
                  },
                }}
              >
                <Avatar
                  src={spec.imageUrl}
                  alt={spec.name}
                  sx={{
                    width: 200,
                    height: 200,
                    mb: 1,
                    border: '2px solid #92b21f',
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {spec.name}
                </Typography>
                <Link
                  to={generateWhatsappLink(spec.phone, spec.name)}
                  target="_blank"
                  style={{ textDecoration: 'none', width: '100%' }}
                >
                  <Button
                    variant="contained"
                    startIcon={<WhatsAppIcon />}
                    sx={{
                      mt: 3,
                      backgroundColor: '#92b21f',
                      color: 'white',
                      fontWeight: 'bold',
                      px: 4,
                      py: 1.5,
                      '&:hover': {
                        backgroundColor: '#7ca317',
                      },
                    }}
                  >
                    Chamar agora
                  </Button>
                </Link>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SpecialistsSession;
